import React from 'react';
import { useSelector } from 'react-redux';
// @ts-ignore
import { Banner } from '@els/els-react--banner';
// @ts-ignore
import { Button } from '@els/els-react--button';
import { selectAppConfigs } from '../../features/app-config/app-config-selector';
import './warn-banner.scss';

const WarnBanner = (props: any) => {
    const {
        name,
        isBannerVisible,
        onCloseBannerHandler,
        isNamePlural,
        size,
        noCloseIcon,
    } = props;

    const appConfigs = useSelector(selectAppConfigs);

    const onClickLinkHandler = () => {
        window.open(`${appConfigs.SUPPORT_HUB_CONTACT_US_URL}`, '_blank');
    };
    const baseClassName = 'warn-banner-container';

    return (
        <Banner
            className={`${baseClassName}-banner`}
            isVisible={isBannerVisible}
            isFilled
            type="warn"
            size={size}
            hideCloseLabel
            onClose={!noCloseIcon ? () => onCloseBannerHandler() : undefined}
        >
            <b>
                Unfortunately,&nbsp;
                {name}
                &nbsp;
                {isNamePlural ? 'are' : 'is'}
                &nbsp;temporarily unavailable.
            </b>
            <span>
                &nbsp;You can try again later or
                <Button type="link" onClick={onClickLinkHandler}>
                    &nbsp;report it to support&nbsp;
                </Button>
                if the issue continues.
            </span>
        </Banner>
    );
};

export default WarnBanner;
